import './App.css';
import { Box } from '@mui/material';
import Board from './Components/Board';
import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import Notifications from './Notifications';
import Chat from './Components/Chat';
import { useDispatch } from 'react-redux';
import { initializeApp } from 'firebase/app';
import { getAnalytics } from "firebase/analytics";
import { appendMessage, setAnalyticsInstance, setCallParticipants, setConnected, setGame, setMessages, setPresence } from './services/GameSlice';
import { setBody, setType } from './services/NotificationSlice';
import { getSocket } from './socket';
import ContentLayout from './Components/Layout/ContentLayout';
import HowToPlay from './Components/Pages/HowToPlay';
import Strategy from './Components/Pages/Strategy';
import About from './Components/Pages/About';
import FAQ from './Components/Pages/FAQ';
import PrivacyPolicy from './Components/Pages/PrivacyPolicy';
import TermsOfService from './Components/Pages/TermsOfService';
import Contact from './Components/Pages/Contact';
import Leaderboard from './Components/Pages/Leaderboard';
import Replay from './Components/Replay';
import Classic from './Components/Classic';
import { gamePath, prefersClassic } from './uiMode';

// A game link opens in the look this browser last chose.
const Game = () => {
  const { gameId } = useParams();
  if (prefersClassic()) {
    return <Navigate to={gamePath(gameId, true)} replace />;
  }
  return <><Chat /><Board /></>;
};

function App() {
  const dispatch = useDispatch();

  const firebaseConfig = {
    apiKey: "AIzaSyDxbgKv9nThMpKYIzv9U7R-JQAXFAUAftA",
    authDomain: "play-sequence.firebaseapp.com",
    projectId: "play-sequence",
    storageBucket: "play-sequence.appspot.com",
    messagingSenderId: "154367757387",
    appId: "1:154367757387:web:185111808b8235ec9091ce",
    measurementId: "G-0JSK5D2DNH"
  };

  useEffect(() => {
    const app = initializeApp(firebaseConfig);
    const analytics = getAnalytics(app);
    dispatch(setAnalyticsInstance(analytics));
    // eslint-disable-next-line
  }, [dispatch])

  // Single place where server pushes are turned into store updates. Mounted
  // once for the whole app so listeners are never registered twice.
  useEffect(() => {
    const socket = getSocket();

    const onConnect = () => dispatch(setConnected(true));
    const onDisconnect = () => dispatch(setConnected(false));
    const onGameUpdate = (game) => dispatch(setGame(game));
    const onPresence = (presence) => dispatch(setPresence(presence));
    const onChatHistory = (messages) => dispatch(setMessages(messages));
    const onChatMessage = (message) => dispatch(appendMessage(message));
    const onCallParticipants = (call) => dispatch(setCallParticipants(call));
    const onError = (error) => {
      dispatch(setType('error'));
      dispatch(setBody(error?.message || 'Something went wrong'));
    };

    socket.on('connect', onConnect);
    socket.on('disconnect', onDisconnect);
    socket.on('game:update', onGameUpdate);
    socket.on('game:presence', onPresence);
    socket.on('chat:history', onChatHistory);
    socket.on('chat:message', onChatMessage);
    socket.on('call:participants', onCallParticipants);
    socket.on('game:error', onError);

    if (socket.connected) {
      dispatch(setConnected(true));
    }

    return () => {
      socket.off('connect', onConnect);
      socket.off('disconnect', onDisconnect);
      socket.off('game:update', onGameUpdate);
      socket.off('game:presence', onPresence);
      socket.off('chat:history', onChatHistory);
      socket.off('chat:message', onChatMessage);
      socket.off('call:participants', onCallParticipants);
      socket.off('game:error', onError);
    };
  }, [dispatch])

  return (
    <Box>
      <Notifications />
      <Routes>
        <Route path='/' element={<Game />} />
        <Route path='/r/:gameId' element={<Replay />} />
        <Route path='/classic' element={<Classic />} />
        <Route path='/classic/:gameId' element={<Classic />} />
        <Route path='/:gameId' element={<Game />} />
        <Route element={<ContentLayout />}>
          <Route path='/how-to-play' element={<HowToPlay />} />
          <Route path='/strategy' element={<Strategy />} />
          <Route path='/about' element={<About />} />
          <Route path='/faq' element={<FAQ />} />
          <Route path='/privacy-policy' element={<PrivacyPolicy />} />
          <Route path='/terms' element={<TermsOfService />} />
          <Route path='/contact' element={<Contact />} />
          <Route path='/leaderboard' element={<Leaderboard />} />
        </Route>
      </Routes>
    </Box>
  );
}

export default App;
